
document.addEventListener("DOMContentLoaded", function () {
    const accordionItems = document.querySelectorAll(".vertical_accordion-item");

    function handleAccordionClick(item) {
        const isActive = item.classList.contains("active");

        // Close all items
        accordionItems.forEach(i => {
            i.classList.remove("active");
            i.setAttribute("aria-expanded", "false");
            i.querySelector('.content').setAttribute('aria-hidden', 'true');
        });

        // If not already active, open the clicked item
        if (!isActive) {
            item.classList.add("active");
            item.setAttribute("aria-expanded", "true");
            item.querySelector('.content').setAttribute('aria-hidden', 'false');
            item.focus(); // Ensure focus is applied to active item
        }
    }

    // Click handling
    accordionItems.forEach(item => {
        item.setAttribute("tabindex", "0"); // Make focusable
        item.setAttribute("role", "tab");
        item.setAttribute("aria-expanded", "false");

        const content = item.querySelector('.content');
        content.setAttribute("role", "tabpanel");
        content.setAttribute("aria-hidden", "true");

        item.addEventListener("click", () => handleAccordionClick(item));

        // Keyboard accessibility
        item.addEventListener("keydown", (event) => {
            switch (event.key) {
                case "Enter":
                case " ":
                    event.preventDefault();
                    handleAccordionClick(item);
                    break;
                case "ArrowDown":
                    focusNextItem(item);
                    break;
                case "ArrowUp":
                    focusPreviousItem(item);
                    break;
            }
        });
    });

    // Handle focus for next and previous items
    function focusNextItem(currentItem) {
        const nextItem = currentItem.nextElementSibling || accordionItems[0];
        nextItem.focus();
    }

    function focusPreviousItem(currentItem) {
        const prevItem = currentItem.previousElementSibling || accordionItems[accordionItems.length - 1];
        prevItem.focus();
    }

    // Collapse accordions on window resize (if below 960px)
    window.addEventListener("resize", () => {
        if (window.innerWidth < 960) {
            accordionItems.forEach(i => {
                i.classList.remove("active");
                i.setAttribute("aria-expanded", "false");
                i.querySelector('.content').setAttribute('aria-hidden', 'true');
            });
        }
    });

    // Initial collapse on load if viewport is below 960px
    if (window.innerWidth < 960) {
        accordionItems.forEach(i => {
            i.classList.remove("active");
            i.setAttribute("aria-expanded", "false");
            i.querySelector('.content').setAttribute('aria-hidden', 'true');
        });
    }
});

// Function to toggle classes based on the clicked index
function toggleDirectionClass() {
    document.querySelectorAll(".accordions_vertical_scroll_wrapper").forEach(wrapper => {
        const titles = wrapper.querySelectorAll(".vertical_accordion-item .title");

        titles.forEach((title, index) => {
            title.addEventListener("click", function () {
                let isActive = title.classList.contains("ps-s-accordiontitle-left");

                // Toggle classes based on the clicked index
                titles.forEach((t, i) => {
                    if (i <= index && !isActive) {
                        t.classList.add("ps-s-accordiontitle-left");
                    } else if (i >= index) {
                        t.classList.remove("ps-s-accordiontitle-left");
                    }
                });
            });
        });
    });
}

toggleDirectionClass();
